export const ADD_TO_ORDER = "ADD_TO_ORDER";
export const REMOVE_FROM_ORDER = "REMOVE_FROM_ORDER";
export const UPDATE_ORDER_ITEM = "UPDATE_ORDER_ITEM";
export const CLEAR_ORDER = "CLEAR_ORDER";

export const addToOrder = (item) => {
  return {
    type: ADD_TO_ORDER,
    payload: item,
  };
};

export const removeFromOrder = (lineId) => {
  return {
    type: REMOVE_FROM_ORDER,
    payload: lineId,
  };
};

export const updateOrderItem = (lineId, data) => {
  return {
    type: UPDATE_ORDER_ITEM,
    payload: {
      lineId,
      data,
    },
  };
};

export const clearOrder = () => {
  return {
    type: CLEAR_ORDER,
  };
};